import React, { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";

// Renders PDF pages to canvas so the preview works in every browser (Safari shows blob PDFs as a placeholder).
export function PdfViewer({ blob, src, className = "", testid }) {
  const box = useRef(null);
  const [state, setState] = useState("loading");
  useEffect(() => {
    let cancelled = false;
    const el = box.current;
    (async () => {
      try {
        const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
        pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString();
        const data = blob ? await blob.arrayBuffer() : await (await fetch(src, { credentials: "include" })).arrayBuffer();
        const doc = await pdfjs.getDocument({ data, isEvalSupported: false }).promise;
        el.innerHTML = "";
        const width = el.clientWidth - 16;
        for (let n = 1; n <= doc.numPages && !cancelled; n += 1) {
          const page = await doc.getPage(n);
          const base = page.getViewport({ scale: 1 });
          const ratio = window.devicePixelRatio || 1;
          const vp = page.getViewport({ scale: (width / base.width) * ratio });
          const canvas = document.createElement("canvas");
          canvas.width = vp.width; canvas.height = vp.height;
          canvas.style.width = `${vp.width / ratio}px`;
          canvas.className = "mx-auto mb-3 shadow bg-white";
          el.appendChild(canvas);
          await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
        }
        if (!cancelled) setState("ok");
      } catch {
        if (!cancelled) setState("error");
      }
    })();
    return () => { cancelled = true; };
  }, [blob, src]);
  return (
    <div className={`relative overflow-auto rounded border border-border bg-muted/40 p-2 ${className}`} data-testid={testid}>
      {state === "loading" && <p className="absolute inset-0 flex items-center justify-center gap-2 text-sm text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento PDF…</p>}
      {state === "error" && <p className="p-6 text-center text-sm text-muted-foreground" data-testid={`${testid}-error`}>Anteprima non disponibile: usa "Apri in nuova scheda" o "Scarica PDF".</p>}
      <div ref={box} />
    </div>
  );
}
